(() => {
  'use strict';
  const amount = (variant, allocation, quantity = 1) => {
    const original = variant.price * quantity;
    const total = allocation ? allocation.price * quantity : original - Math.round(original * variant.once_discount / 100);
    return {original, total, saving: original > 0 ? Math.round((original - total) * 100 / original) : 0,
      days: variant.days * quantity, daily: variant.days > 0 ? total / (variant.days * quantity) : null};
  };
  const unit = (variant, allocation, quantity = 1) => {
    const value = amount(variant, allocation, quantity);
    const bottles = Math.max(1, variant.bottles || variant.months || 1) * quantity;
    return {...value, original: value.original / bottles, total: value.total / bottles};
  };
  // Public properties appear under each native checkout item. Per-supply savings
  // remain accurate when the customer changes the number of supplies in checkout.
  const offerProperties = (properties, original, total, months, money) => {
    const result = {...properties};
    delete result['Your savings'];
    if (original > total && original > 0) {
      const saved = original - total, percent = Math.round(saved * 100 / original);
      result['Your savings'] = `Save ${money(saved)} (${percent}%) per ${months}-month supply`;
    }
    return result;
  };
  window.NutrafolPricing = Object.freeze({amount, unit, offerProperties});
})();
